import { render } from "./InThePress.vue?vue&type=template&id=948de294"
import script from "./InThePress.vue?vue&type=script&lang=js"
export * from "./InThePress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__